export default __webpack_public_path__ + "static/media/logo-icon.41631ccc.svg";